import {
  ADD_MANUAL_AMOUNT_SUCCESS,
  ADD_MANUAL_AMOUNT_FAILED,
  RESET_ADD_MANUAL_AMOUNT,
  LOADING_ADD_MANUAL_AMOUNT,
  NETWORK_ERROR_ADD_MANUAL_AMOUNT,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  nvalidRequest: false,
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_ADD_MANUAL_AMOUNT: {
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case ADD_MANUAL_AMOUNT_FAILED: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        data: action.payload,
      };
    }
    case ADD_MANUAL_AMOUNT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        data: action.payload,
      };
    }

    case RESET_ADD_MANUAL_AMOUNT: {
      return (state = initialState);
    }

    default:
      return state;
  }
};
